<xemex-page-header
  [title]="'sidebarMenu.alarms' | translate"
  [withBackground]="true"
  [withTabBar]="true"
  [breadcrumbs]="[
    { label: 'sidebarMenu.home' | translate, routerLink: '/' },
    { label: 'sidebarMenu.alarms' | translate },
  ]"
  [icon]="'alarm'"
>
  <xemex-tab-bar
    [tabs]="ALARMS_TABS()"
    [defaultTab]="0"
    (tabChange)="onTabChange($event)"
  ></xemex-tab-bar>
</xemex-page-header>

@if (selectedTab === 'overview') {
  <xemex-page-body [scrollable]="true">
    <xemex-alarms-overview-tab [initialFilters]="initialFilters"></xemex-alarms-overview-tab>
  </xemex-page-body>
}

@if (selectedTab === 'settings' && canManageSettings()) {
  <xemex-page-body [scrollable]="true">
    <xemex-alarms-settings-tab></xemex-alarms-settings-tab>
  </xemex-page-body>
}
